import {getAuthorizationHeader, getTokenFromCookies} from '@/api/common-utils';
import {BaseApi} from '@/api/base-api';

class ProfileApi extends BaseApi {
  private static readonly baseUrl: string = `https://api.searchatlas.com/api/customer`;

  public async getProfile() {
    const headers = {};
    const token = getTokenFromCookies();

    if (token ) {
      headers['Authorization'] = getAuthorizationHeader();
      try {
        const response = await this.axios.get(`${ProfileApi.baseUrl}/account/user/`, {
          headers: headers,
          cancelToken: this.cancelToken,
        });
        return response.data;
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }
  public async getQuota(userId) {
    const headers = {};
    const token = getTokenFromCookies();

    if (token ) {
      headers['Authorization'] = getAuthorizationHeader();
      try {
        const response = await this.axios.get(`${ProfileApi.baseUrl}/account/addon-extended-details/${userId}/`, {
          headers: headers,
          cancelToken: this.cancelToken,
        });
        return response;
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }
}

export default ProfileApi;
